import type {Schemas} from 'api/dto.generated';
import {mapManifestationWithExpressionDto} from './mapManifestationWithExpressionDto';
import type {FullManifestation} from '../types';

export const mapManifestationsDto = (
  dto: Schemas.ManifestationsDto,
): FullManifestation[] => {
  return (
    dto.manifestations?.map(m => mapManifestationWithExpressionDto(m)) || []
  );
};
